export default __webpack_public_path__ + "static/squarering-674988e061a586d72881e58921ebc087.png";